import api, { setAccessToken, setRefreshToken, clearTokens } from './api';
import type {
  LoginRequest,
  LoginResponse,
  User,
} from '@/types';

const AUTH_ENDPOINTS = {
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  ME: '/auth/me',
  REFRESH: '/auth/refresh',
};

export const authService = {
  /**
   * Login admin user with email and password
   */
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>(AUTH_ENDPOINTS.LOGIN, credentials);
    const { accessToken, refreshToken } = response.data;

    // Store tokens
    setAccessToken(accessToken);
    setRefreshToken(refreshToken);

    return response.data;
  },

  /**
   * Logout admin user
   */
  async logout(): Promise<void> {
    try {
      await api.post(AUTH_ENDPOINTS.LOGOUT);
    } catch {
      // Even if the API call fails, clear local tokens
    } finally {
      clearTokens();
    }
  },

  /**
   * Get current admin user profile
   */
  async getMe(): Promise<User> {
    const response = await api.get<User>(AUTH_ENDPOINTS.ME);
    return response.data;
  },

  /**
   * Refresh access token
   */
  async refreshToken(refreshToken: string): Promise<{ accessToken: string }> {
    const response = await api.post<{ accessToken: string }>(AUTH_ENDPOINTS.REFRESH, {
      refreshToken,
    });
    setAccessToken(response.data.accessToken);
    return response.data;
  },
};

export default authService;
